var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-4 pb-4",class:{ 'border-b' : !_vm.last }},[_c('div',{staticClass:"text-sm text-gray-600"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"mt-2"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }